import api from 'api/apiInstance';

export function clientCaseRiskAssessmentsPrintApi(path: string) {
  return {
    path,
    GET: () => api.get(path),
  };
}
